import { api } from './api.util';

/**
 * Check if user has purchased a specific exam
 * @param {string} examId - The exam ID to check
 * @returns {Promise} Purchase status data
 */
export const checkExamPurchase = async (examId) => {
  try {
    const response = await api.get(`/purchases/check/${examId}`);
    return response;
  } catch (error) {
    console.error('Error checking exam purchase:', error);
    throw error;
  }
};

/**
 * Get exam purchase information
 * @param {string} examId - The exam ID
 * @returns {Promise} Exam purchase info
 */
export const getExamPurchaseInfo = async (examId) => {
  try {
    const response = await api.get(`/purchases/exam-info/${examId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting exam purchase info:', error);
    throw error;
  }
};

/**
 * Get user's purchased exams
 * @returns {Promise} User's purchased exams
 */
export const getMyPurchasedExams = async () => {
  try {
    const response = await api.get('/purchases/my-exams');
    return response.data;
  } catch (error) {
    console.error('Error getting purchased exams:', error);
    throw error;
  }
};

/**
 * Create Razorpay order for exam purchase
 * @param {string} examId - The exam ID to purchase
 * @param {object} options - Purchase options including purchaseType
 * @returns {Promise} Order creation result
 */
export const createExamPurchaseOrder = async (examId, options = {}) => {
  try {
    const { purchaseType = 'full' } = options;
    const response = await api.post(`/purchases/create-order/${examId}`, {
      purchaseType
    });
    return response;
  } catch (error) {
    console.error('Error creating purchase order:', error);
    throw error;
  }
};

/**
 * Purchase an exam with Razorpay payment details
 * @param {string} examId - The exam ID to purchase
 * @param {object} paymentDetails - Razorpay payment details including purchaseType
 * @returns {Promise} Purchase result
 */
export const purchaseExam = async (examId, paymentDetails) => {
  try {
    const response = await api.post(`/purchases/buy-exam/${examId}`, {
      razorpay_order_id: paymentDetails.razorpay_order_id,
      razorpay_payment_id: paymentDetails.razorpay_payment_id,
      razorpay_signature: paymentDetails.razorpay_signature,
      purchaseType: paymentDetails.purchaseType || 'full'
    });
    return response;
  } catch (error) {
    console.error('Error purchasing exam:', error);
    throw error;
  }
};
